import apiClient from "./apiClient";
import { asEntityId } from "../utils/commonutils";

const Url = `/casemanagement`;

// ---------------------- GET CASE LIST ----------------------
export const getCases = async (props, currentPage, rowsPerPage, searchText) => {
  try {
    let url = `${Url}/list?page=${currentPage}&limit=${rowsPerPage}`;

    if (
      searchText !== null &&
      searchText !== undefined &&
      searchText.trim() !== ""
    ) {
      url += `&search=${encodeURIComponent(searchText.trim())}`;
    }

    let response = await apiClient.get(url);

    return response.data;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

// ---------------------- GET CASE DETAIL ----------------------
export const getCaseDetail = async (payload, props) => {
  try {
    if (!payload || !payload.caseId) return false;

    let response = await apiClient.get(`${Url}/${payload.caseId}`);

    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

// ---------------------- ADD CASE ----------------------
export const addCase = async (props, Data) => {
  try {
    let body = {
      caseId: Data.caseId,
      customerId: asEntityId(Data?.taxPayerName),
      GSTIN: Data.GSTIN,
      subject: Data.subject,
      amount: Data.amount,
      stage: Data.stage,
      status: Data.status,
      assignedTo: asEntityId(Data?.assignedTo?.userId) || asEntityId(Data?.assignedTo),
      DRC01AReceived: Data.DRC01AReceived,
    };

    let response = await apiClient.post(Url, body);
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};

// ---------------------- EDIT CASE ----------------------
export const editCase = async (props, Data, editId) => {
  try {
    let rawBody = {
      caseId: Data.caseId,
      customerId: asEntityId(Data?.taxPayerName),
      GSTIN: Data.GSTIN,
      subject: Data.subject,
      amount: Data.amount,
      stage: Data.stage,
      status: Data.status,
      assignedTo: asEntityId(Data?.assignedTo?.userId) || asEntityId(Data?.assignedTo),
      DRC01AReceived: Data.DRC01AReceived,
      replayToDRC01A: Data.replayToDRC01A,
      DRC01CauseDate: Data.DRC01CauseDate,
      replayToDRC01: Data.replayToDRC01,
      additionalClarification: Data.additionalClarification,
      hearingNotice: Data.hearingNotice,
      wrritenSubmissionFiled: Data.wrritenSubmissionFiled,
      hearing1: Data.hearing1,
      hearing2: Data.hearing2,
      hearing3: Data.hearing3,
      orderDate: Data.orderDate,
      orderPassed: Data.orderPassed,
      demandStatus: Data.demandStatus,
      DRC07issued: Data.DRC07issued,
      appealFiledDate: Data.appealFiledDate,
      appealAckNo: Data.appealAckNo,
      appealHearing1: Data.appealHearing1,
      appealHearing2: Data.appealHearing2,
      appellateOrderPassed: Data.appellateOrderPassed,
      highCourtWritFiled: Data.highCourtWritFiled,
      HCHearing1: Data.HCHearing1,
      HCHearing2: Data.HCHearing2,
      HCHearing3: Data.HCHearing3,
      HCHearing4: Data.HCHearing4,
      highCourtOrder: Data.highCourtOrder,
    };

    // 2️⃣ Remove fields: undefined, null, empty string
    let body = Object.fromEntries(
      Object.entries(rawBody).filter(
        ([key, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    // 3️⃣ API Call
    let response = await apiClient.put(`${Url}?caseManagementId=${editId}`, body);

    if (response && response.status === 200) return response.data;
    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
// ---------------------- DELETE CASE ----------------------
export const deleteCase = async (caseId, props) => {
  try {
    if (!caseId) return false;

    let response = await apiClient.delete(`${Url}?caseManagementId=${caseId}`);

    return response;
  } catch (error) {
    console.log("error", error, error.response);
    return error;
  }
};
